import { type RovoContentBridgeAPIShape } from '@atlassian/rovo-content-bridge-api/dist/types/rovo-bridge-api-interface';
import { type ConfluenceCreateDatabaseCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { logError } from '@databases/logs';

import { getConfluenceService } from '@canvas/atlassian-service/confluence';

import { DatabaseStreamState } from '../database-stream-state';
import { sendDatabaseAIFCExperienceTrackingToParent } from '../metrics/rovo-bridge-metrics';

const streamState = DatabaseStreamState.getInstance();

export const createDatabase = async (
  params: ConfluenceCreateDatabaseCommandProperties,
  contentId: string,
  bridge: RovoContentBridgeAPIShape
) => {
  try {
    if (params.isStreamComplete) {
      try {
        await getConfluenceService().updateContentTitle(contentId, params.data.title);
      } catch (possibleError) {
        const error =
          possibleError instanceof Error
            ? possibleError
            : new Error(String(possibleError));
        logError('Error updating native database title', error);
        throw error;
      } finally {
        await streamState.completeStreaming();
        sendDatabaseAIFCExperienceTrackingToParent({
          status: 'success',
          bridge,
          experienceName: 'aiMateAifcAllDataHandled',
          contentId,
        });
      }
      return;
    }

    if (!streamState.isStreamingActive) {
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        bridge,
        experienceName: 'aiMateAifcInitialDataReceived',
        contentId,
      });
      streamState.startStreaming(contentId, params.groupId, {
        shouldClearContent: true,
      });
    }

    streamState.processChunk(params.data.document);
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    sendDatabaseAIFCExperienceTrackingToParent({
      status: 'fail',
      error,
      bridge,
      experienceName: 'aiMateAifcAllDataHandled',
      contentId,
    });
    throw error;
  }
};
